import {useContext, useEffect, useRef, useState} from "react";

// Context
import {UserAuthenticationContext} from "../../../../Context/UserAuthenticationContext";

// Helpers
import {SetTitle} from "../../../../Helpers/PageMetadata";

// Components
import SliderFeaturedContent from "../../../../Components/Layouts/Content/SliderFeaturedContent";
import VideoContentGridLandscape from "../../../../Components/Layouts/Content/Watch/VideoFeed/VideoContentGridLandscape";

// Hooks
import useFetchSeriesList from "../../../../Hooks/Content/Watch/Series/useFetchSeriesList";

function SeriesFeed() {
    const
        {userData} = useContext(UserAuthenticationContext),

        TAKE = 50,
        [skip, setSkip] = useState(0),
        shouldAppendData = skip > 0,

        {series, seriesLoading, seriesError} = useFetchSeriesList(
            TAKE,
            skip,
            shouldAppendData
        ),

        lastRequestedSkipRef = useRef<number | null>(null),
        [done, setDone] = useState(false);

    useEffect
    (() => {
        SetTitle("Series");
    }, []);

    useEffect(() => {
        if (done) return;
        if (seriesLoading) return;
        if (seriesError) return;

        // same heuristic as FilmsFeed:
        // final page likely returned fewer than TAKE
        const looksLikeFinalPage =
            series.length > 0 && series.length % TAKE !== 0;

        if (looksLikeFinalPage) {
            setDone(true);
            return;
        }

        if (series.length === 0) return;

        const nextSkip = series.length;

        if (lastRequestedSkipRef.current === nextSkip) return;
        lastRequestedSkipRef.current = nextSkip;

        setSkip(nextSkip);
    }, [series, seriesLoading, seriesError, done]);

    const gridIsLoading = series.length === 0 && seriesLoading;

    return (
        <>
            <SliderFeaturedContent
                sliderId={4}
                classNameInner="front-page"
                userDetails={userData}
            />

            <div className="page page--series">
                <h1>All Series</h1>

                <VideoContentGridLandscape
                    isDarkMode={true}
                    carouselItems={series}
                    isLoading={gridIsLoading}
                    backgroundHex="#151515"
                />
            </div>
        </>
    );
}

export default SeriesFeed;
